/**
 * Mobile Menu Handler
 * Gère l'ouverture/fermeture du menu mobile et les sous-menus
 */
class MobileMenu {
    constructor() {
        this.menuToggle = document.querySelector('.lrd-header__menu-mobile');
        this.mobileMenu = document.querySelector('.lrd-mobile-menu');
        this.overlay = document.querySelector('.lrd-mobile-overlay');
        this.closeButton = document.querySelector('.lrd-mobile-menu__close');
        this.body = document.body;
        
        this.init();
    }

    init() {
        // Événements pour ouvrir/fermer le menu
        this.menuToggle?.addEventListener('click', () => this.toggleMenu());
        this.closeButton?.addEventListener('click', () => this.closeMenu());
        this.overlay?.addEventListener('click', () => this.closeMenu());

        // Gestion des sous-menus
        this.initSubMenus();

        // Fermer le menu avec la touche Escape
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.mobileMenu?.classList.contains('active')) {
                this.closeMenu();
            }
        });

        // Fermer le menu lors du redimensionnement de la fenêtre
        window.addEventListener('resize', () => {
            if (window.innerWidth >= 1024 && this.mobileMenu?.classList.contains('active')) {
                this.closeMenu();
            }
        });
    }

    toggleMenu() {
        if (this.mobileMenu?.classList.contains('active')) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.mobileMenu?.classList.add('active');
        this.overlay?.classList.add('active');
        this.menuToggle?.classList.add('active');
        this.body.classList.add('menu-open');
    }

    closeMenu() {
        this.mobileMenu?.classList.remove('active');
        this.overlay?.classList.remove('active');
        this.menuToggle?.classList.remove('active');
        this.body.classList.remove('menu-open');
        
        // Fermer tous les sous-menus ouverts
        this.closeAllSubMenus();
    }

    initSubMenus() {
        const menuItemsWithChildren = document.querySelectorAll('.lrd-mobile-menu__menu .menu-item-has-children > a');
        const menuItemsWithChildrenDesktop = document.querySelectorAll('.lrd-header__menu .menu-item-has-children > a');

        menuItemsWithChildrenDesktop.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleSubMenu(item.parentElement);
            });
        });
        
        menuItemsWithChildren.forEach(item => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleSubMenu(item.parentElement);
            });
        });
    }

    toggleSubMenu(menuItem) {
        const subMenu = menuItem.querySelector('.sub-menu');
        const isActive = menuItem.classList.contains('active');
        const body = document.body;

        // Fermer tous les autres sous-menus
        if (!isActive) {
            this.closeAllSubMenus();
        }

        // Toggle le sous-menu actuel
        menuItem.classList.toggle('active');
        subMenu?.classList.toggle('active');

        if(subMenu.classList.contains('active')) {
            // Ajouter un délai pour éviter que l'événement se déclenche immédiatement
            setTimeout(() => {
                body.addEventListener('click', () => {
                    this.closeAllSubMenus();
                }, { once: true });
            }, 100);
        }
    }

    closeAllSubMenus() {
        const activeSubMenus = document.querySelectorAll('.lrd-mobile-menu__menu .menu-item-has-children.active');
        const activeSubMenusDesktop = document.querySelectorAll('.lrd-header__menu .menu-item-has-children.active');
        activeSubMenus.forEach(item => {
            item.classList.remove('active');
            const subMenu = item.querySelector('.sub-menu');
            subMenu?.classList.remove('active');
        });
        activeSubMenusDesktop.forEach(item => {
            item.classList.remove('active');
            const subMenu = item.querySelector('.sub-menu');
            subMenu?.classList.remove('active');
        });
    }

}

// Initialiser le menu mobile quand le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
    new MobileMenu();
}); 